import { createSlice } from "@reduxjs/toolkit";
import deleteReviewStatus from "@custom/rtk-apis/teleradiologist/deleteReviewStatus";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const deleteReviewStudyStatusSlice = createSlice({
  name: "changeReviewStudyStatusSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteReviewStatus.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteReviewStatus.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(deleteReviewStatus.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deleteReviewStudyStatusSlice.reducer;
export const { closeModal } = deleteReviewStudyStatusSlice.actions;
